import { render, staticRenderFns } from "./ModalDestroy.vue?vue&type=template&id=2e12d92b"
import script from "./ModalDestroy.vue?vue&type=script&lang=js"
export * from "./ModalDestroy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports